import { Row, Tooltip } from "antd";
import { CiGlobe } from "react-icons/ci";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaWhatsapp } from "react-icons/fa6";
import { formatCep, SearchResultData } from "../../router/SearchResultTable";
import { SiOpenai } from "react-icons/si";
import { resumoEmpresaGpt } from "../../lib/resumoEmpresaGpt";
import { subclasseSelect } from "../../config/data";
import { IoIosCode, IoLogoGoogle } from "react-icons/io";
import { usePostHog } from "posthog-js/react";

type IconsProps = {
    setSelectedRecord: any,
    userPermissions:any,
    setApiResponse: any,
    setModalLoading:any,
    setIsModalVisible:any,
    setIsTechModalVisible: any
    record: SearchResultData
  };
  
    export const TechButton = ({
        record,
        setIsTechModalVisible,
        setSelectedRecord
      }: {
        record: SearchResultData;
        setIsTechModalVisible: (visible: boolean) => void;
        setSelectedRecord: any
      }) => {
        const handleTechModal = () => {
          if(!record.dominio_email) return
          setSelectedRecord(record);
          setIsTechModalVisible(true);
        };
    
        return (
          <div>
            <Tooltip title={record.dominio_email ?"Tech " : "Não disponnível"}>
              <IoIosCode
                style={record.dominio_email ? { cursor: "pointer", color: "#33EA89",transform:'scale(1.25)' } : { color: "gray",transform:'scale(1.25)' }}
                onClick={handleTechModal}
              />
            </Tooltip>
          </div>
        );
      };

  const Icons = ({
    setSelectedRecord,
    userPermissions,
    setApiResponse,
    setModalLoading,
    setIsModalVisible,
    setIsTechModalVisible,
    record
}: IconsProps) => {
    const posthog = usePostHog();
    const OpenAiButton = ({
        record,
        setApiResponse,
        setModalLoading,
        setIsModalVisible,
      }: {
        record: SearchResultData;
        setApiResponse: (response: Record<string, any> | null) => void;
        setModalLoading: (loading: boolean) => void;
        setIsModalVisible: (visible: boolean) => void;
      }) => {
        const handleClick = async () => {
          const cacheKey = `${record.cnpj_completo}/resumo`;
          const cachedResponse = localStorage.getItem(cacheKey);
    
          if (cachedResponse) {
            setApiResponse(JSON.parse(cachedResponse));
            return;
          }
          setModalLoading(true);
          try {
            const response = await resumoEmpresaGpt(
              record,
              subclasseSelect.find(
                (element: any) => element.value === record.cnae_principal,
              )?.label || "",
            );
            localStorage.setItem(cacheKey, JSON.stringify(response));
            setApiResponse(response);
          } catch (error) {
            console.error("Error fetching data:", error);
            setApiResponse({ error: "Error fetching data" });
          }
          setModalLoading(false);
        };
    
        const handleOpenModal = () => {
          if(!record.dominio_email) return
          setSelectedRecord(record);
          setIsModalVisible(true);
          handleClick();
        };
    
        return (
          <div>
            <Tooltip title={record.dominio_email ? "ChatGPT" : "Não disponível"}>
              <SiOpenai
                style={record.dominio_email ? { cursor: "pointer", color: "#33EA89" } : {color:'gray'}}
                onClick={()=>{
                  posthog.capture('openai_button_click');
                  handleOpenModal();
                }}
              />
            </Tooltip>
          </div>
        );
      };


    return(
        <div>
            <Row style={{ justifyContent: "space-around", width:'25vh',  minWidth: '15em'}}>
              <Tooltip
                title={
                  record.linkedin ? record.linkedin : "Não disponível"
                }
              >
                <FaLinkedinIn
                  style={
                    record.linkedin
                      ? { cursor: "pointer", color: "#33EA89" }
                      : { color: "gray" }
                  }
                  onClick={() => {
                    posthog.capture('linkedin_button_click');
                    if (record.linkedin)
                      window.open(`${record.linkedin}`, "_blank");
                  }}
                />
              </Tooltip>
              <Tooltip
                title={
                  record.facebook ? record.facebook : "Não disponível"
                }
              >
                <FaFacebookF
                  style={
                    record.facebook
                      ? { cursor: "pointer", color: "#33EA89" }
                      : { color: "gray" }
                  }
                  onClick={() => {
                    posthog.capture('facebook_button_click');
                    if (record.facebook)
                      window.open(`${record.facebook}`, "_blank");
                  }}
                />
              </Tooltip>
              <Tooltip
                title={
                  record.dominio_email
                    ? record.dominio_email
                    : "Não disponível"
                }
              >
                <CiGlobe
                  style={
                    record.dominio_email
                      ? { cursor: "pointer", color: "#33EA89" }
                      : { color: "gray" }
                  }
                  onClick={() => {
                    if (record.dominio_email)
                      window.open(
                        `https://${record.dominio_email}`,
                        "_blank",
                      );
                  }}
                />
              </Tooltip>
              <Tooltip
                title={
                  record.instagram ? record.instagram : "Não disponível"
                }
              >
                <FaInstagram
                  style={
                    record.instagram
                      ? { cursor: "pointer", color: "#33EA89" }
                      : { color: "gray" }
                  }
                  onClick={() => {
                    posthog.capture('instagram_button_click');
                    if (record.instagram)
                      window.open(`${record.instagram}`, "_blank");
                  }}
                />
              </Tooltip>
              <Tooltip title={"Pesquisar no Google"}>
                <IoLogoGoogle
                  style={{ cursor: "pointer", color: '#33EA89' }}
                  onClick={() => {
                    window.open(
                      `https://www.google.com/search?q=${record.nome_fantasia.replaceAll(",", "+")}+${record.razao_social.replaceAll(",", "+")}+${record.logradouro.replaceAll(",", "+")}+${record.bairro}+${record.municipio}+${record.uf}+${formatCep(record.cep)}`,
                      "_blank",
                    );
                  }}
                />
              </Tooltip>
              <Tooltip
                title={
                  record.whatsapp
                    ? "WhatsApp no site: " + record.whatsapp
                    : "Não disponível"
                }
              >
                <FaWhatsapp
                  style={
                    record.whatsapp
                      ? { cursor: "pointer", color: "#33EA89" }
                      : { color: "gray" }
                  }
                  onClick={() => {
                    posthog.capture('whatsapp_button_click');
                    if (record.whatsapp)
                      window.open(`${record.whatsapp}`, "_blank");
                  }}
                />
              </Tooltip>
              {userPermissions.ops_gpt ? (
                <OpenAiButton
                  record={record}
                  setApiResponse={setApiResponse}
                  setModalLoading={setModalLoading}
                  setIsModalVisible={setIsModalVisible}
                />
              ) : (
                <></>
              )}
              {userPermissions.ops_tech ? (
                <TechButton
                  record={record}
                  setIsTechModalVisible={setIsTechModalVisible} 
                  setSelectedRecord={setSelectedRecord}                    
                />
                ) : (
                <></>
              )}              
            </Row>
          </div>
    )
}

export default Icons